/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Rights_Access_DescInputs */

const es_privacy_policy_rights_access_desc = /** @type {(inputs: Privacy_Policy_Rights_Access_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solicitar una copia de su informacion personal`)
};

const en_privacy_policy_rights_access_desc = /** @type {(inputs: Privacy_Policy_Rights_Access_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Request a copy of your personal information`)
};

/**
* | output |
* | --- |
* | "Request a copy of your personal information" |
*
* @param {Privacy_Policy_Rights_Access_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_rights_access_desc = /** @type {((inputs?: Privacy_Policy_Rights_Access_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Rights_Access_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_rights_access_desc(inputs)
	return en_privacy_policy_rights_access_desc(inputs)
});
export { privacy_policy_rights_access_desc as "privacy_policy.rights.access_desc" }